/*
 * Strips characters the personalization cannot render from the Product
 * Personalizer text inputs.
 *
 * Loaded only on products that offer personalization - see the gate in
 * sections/product-section.liquid.
 */
(function () {
  var SELECTOR = '.pplr-wrapper .pplr_text';
  /* Grouped by base letter, both cases - a name can start with any of these. */
  var ALLOWED_SYMBOLS =
    " -,’&.|+" +
    "áàâäãåÁÀÂÄÃÅ" +
    "éèêëÉÈÊË" +
    "íìîïīÍÌÎÏĪ" +
    "ñÑ" +
    "óòôöõÓÒÔÖÕ" +
    "úùûüūÚÙÛÜŪ" +
    "æøÆØ";
  var ALPHANUMERIC = /[a-zA-Z0-9]/;
  /* The straight apostrophe is what a keyboard produces; the personalization
     only carries the curly one, so fold it over instead of dropping it. */
  var SUBSTITUTIONS = { "'": '’' };

  function clean(value) {
    /* Pasted text can arrive decomposed - "a" followed by a combining grave -
       and stripping the mark would silently leave a bare letter. Composing
       first turns it back into the single accented character we allow. */
    var normalized = value.normalize ? value.normalize('NFC') : value;
    var result = '';
    for (var i = 0; i < normalized.length; i++) {
      var character = SUBSTITUTIONS[normalized[i]] || normalized[i];
      if (ALPHANUMERIC.test(character) || ALLOWED_SYMBOLS.indexOf(character) !== -1) {
        result += character;
      }
    }
    return result;
  }

  function sanitize(input) {
    var current = input.value;
    if (!current) return;
    var cleaned = clean(current);
    if (cleaned === current) return;
    var caret = input.selectionStart;
    input.value = cleaned;
    if (caret !== null) {
      var caretAfter = caret - (current.length - cleaned.length);
      try { input.setSelectionRange(caretAfter, caretAfter); } catch (e) {}
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* The app writes into these fields itself - the accent keyboard calls
     addthistoinput(), and a saved design is restored on load - which sets
     .value without firing an event. Intercepting the property write covers
     that without scanning on a timer. */
  var VALUE_DESCRIPTOR = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

  function guard(input) {
    if (input.pplrGuarded || !VALUE_DESCRIPTOR) return;
    input.pplrGuarded = true;
    try {
      Object.defineProperty(input, 'value', {
        configurable: true,
        enumerable: true,
        get: function () {
          return VALUE_DESCRIPTOR.get.call(this);
        },
        set: function (incoming) {
          VALUE_DESCRIPTOR.set.call(this, clean(incoming == null ? '' : String(incoming)));
        }
      });
    } catch (e) {}
  }

  function sanitizeAll(root) {
    var inputs = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      guard(inputs[i]);
      sanitize(inputs[i]);
    }
  }

  /* One delegated listener per event type: nothing to rebind when the app
     re-renders its inputs, and capture phase means the app reads the cleaned
     value in its own handlers. */
  function onInput(event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches(SELECTOR)) return;
    if (event.type === 'paste') {
      setTimeout(function () { sanitize(target); }, 0); // value lands after the event
    } else {
      sanitize(target);
    }
  }

  function start() {
    document.addEventListener('input', onInput, true);
    document.addEventListener('change', onInput, true);
    document.addEventListener('paste', onInput, true);

    /* The app injects these inputs itself and can set a value without firing an
       event, so clean each one as it appears rather than polling for changes. */
    sanitizeAll(document);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches(SELECTOR)) { guard(node); sanitize(node); }
          else if (node.querySelector(SELECTOR)) sanitizeAll(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
